//* DESKTOP MEGAMENU JS

const header = document.getElementById('new-main-header');
const transparentHeader = document.getElementById('transparent-header');
let lastScrollY = window.scrollY;
const scrollThreshold = 160;
const minWidth = 991;

const handleScroll = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > lastScrollY && currentScrollY > scrollThreshold) {
        if (!header.classList.contains('sticky')) {
            header.classList.add('sticky');
            header.classList.add('slide-bottom');
            
            if(transparentHeader && transparentHeader.classList.contains('transparent')) {
                transparentHeader.classList.remove('transparent');
            }
        }
    }
    if(currentScrollY < lastScrollY && currentScrollY < scrollThreshold) {
        header.classList.remove('slide-bottom');
        header.classList.add('slide-up');
        setTimeout(function() {
            header.classList.remove('sticky');
            header.classList.remove('slide-up');

            if(transparentHeader && !transparentHeader.classList.contains('transparent')) {
                transparentHeader.classList.add('transparent');
            }
        }, 100);
    }
    lastScrollY = currentScrollY;
};
if (window.innerWidth > minWidth) {
    window.addEventListener('scroll', handleScroll, { passive: true });
}

//* MOBILE MEGAMENU JS
function toggleMobileMegaMenu() {
    document.querySelector('.header-megamenu-container__mobile').classList.toggle('open');
    // $(".mobile-megamenu-left-section .individual-menu-item")[0].click();
    // $(".header-megamenu-container__mobile-redesigned").toggleClass("open");
}

function openIndividualMenu(menuBlock) {
    menuBlock.nextElementSibling.classList.add('open');
    menuBlock.nextElementSibling.classList.remove('closed');
}

function closeIndividualMenu(button) {
    button.parentElement.classList.remove('open');
    button.parentElement.classList.add('closed');
}

function toggleSubSubMenu(subMenu) {
    if(subMenu.classList.contains('open')) {
        subMenu.classList.remove('open');
        subMenu.classList.add('closed');
        subMenu.querySelector('ul.sub-sub-menu-list').classList.remove('open');
        subMenu.querySelector('ul.sub-sub-menu-list').classList.add('closed');
    } else {
        const subMenuItems = subMenu.parentElement.querySelectorAll('.sub-menu-item');
        subMenuItems.forEach(item => {
            if(item.classList.contains('open')) {
                item.classList.remove('open');
                item.classList.add('closed');
                item.querySelector('ul.sub-sub-menu-list').classList.remove('open');
                item.querySelector('ul.sub-sub-menu-list').classList.add('closed');
            } else if(item.classList.contains('closed')) {
                item.classList.remove('closed');
                item.querySelector('ul.sub-sub-menu-list').classList.remove('closed');
            }
        });
        subMenu.classList.add('open');
        subMenu.querySelector('ul.sub-sub-menu-list').classList.add('open');
    }
}

function clickTheLink(block) {
    window.location.href = block.querySelector('a').getAttribute('href');
}

function isIOSDevice() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

document.querySelectorAll(`form > .search-form > .search-input`).forEach(el => {
    el.addEventListener('focus', () => {
        console.log("=====Focus=====");
        if(isIOSDevice()) {
            document.body.style.touchAction = 'none';
        } else {
            document.body.style.overflowY = 'hidden';
        }
    });

    el.addEventListener('blur', () => {
        console.log("=====Defocus=====");
        if(isIOSDevice()) {
            document.body.style.touchAction = 'auto';
        } else {
            document.body.style.overflowY = 'auto';
        }
    });
});
